import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const template = {
  PLACEMENT_ID: {
    DOM: '',
    INTL: ''
  }
}

export const InVibes = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  const { INVIBES = template } = VENDOR
  const { PLACEMENT_ID  } = INVIBES
  const { STRING } = validation
  const { LENGTH } = STRING
  const [expanded, setExpanded] = useState(expandAllVendors)

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='InVibes-panel-content'
        id='InVibes-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>InVibes</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Table size='small' aria-label='InVibes-placement-id-table'>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '180px' }}><Typography variant='h6'>Placement ID</Typography></TableCell>
              <TableCell>Domestic</TableCell>
              <TableCell>International</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextField
                  margin='none'
                  value={PLACEMENT_ID.DOM}
                  error={errors.PREBID_INVIBES_PIDD}
                  helperText={errors.PREBID_INVIBES_PIDD && LENGTH.message}
                  onChange={(event) => {
                    const value = event.target.value
                    PREBID.VENDOR.INVIBES.PLACEMENT_ID.DOM = value
                    setErrors({ ...errors, PREBID_INVIBES_PIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                    setOptions({ ...options, PREBID })
                    setAllOptions({ ...allOptions, PREBID })
                  }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  margin='none'
                  value={PLACEMENT_ID.INTL}
                  error={errors.PREBID_INVIBES_PIDI}
                  helperText={errors.PREBID_INVIBES_PIDI && LENGTH.message}
                  onChange={(event) => {
                    const value = event.target.value
                    PREBID.VENDOR.INVIBES.PLACEMENT_ID.INTL = value
                    setErrors({ ...errors, PREBID_INVIBES_PIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                    setOptions({ ...options, PREBID })
                    setAllOptions({ ...allOptions, PREBID })
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
